import { forwardRef, type ComponentPropsWithoutRef } from "react";
import { Input } from "@shared-kernel/primary/shared/shadcn/ui/input";
import { formatActivityRegistrationNumber } from "@utils/formatting";

interface Props extends Omit<ComponentPropsWithoutRef<typeof Input>, "value" | "onChange"> {
  value: string;
  /** Compatible with RHF field.onChange. */
  onChange: (value: string) => void;
}

/**
 * Activity registration number (NDA) text input: no length limit (a pasted "11 75 12345 67" keeps its
 * spaces until blur), regrouped on blur. Submit-time compaction is done by each form's mapper with
 * `normalizeIdentifier`.
 */
export const ActivityRegistrationNumberInput = forwardRef<HTMLInputElement, Props>(function ActivityRegistrationNumberInput(
  { value, onChange, onBlur, ...inputProps },
  ref,
) {
  return (
    <Input
      {...inputProps}
      ref={ref}
      value={value}
      onChange={e => onChange(e.target.value)}
      onBlur={e => {
        onChange(formatActivityRegistrationNumber(value));
        onBlur?.(e);
      }}
    />
  );
});
